import React, { useRef } from 'react';
import { Link, Redirect, Rout, useHistory } from 'react-router-dom';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  InteractionItem
} from 'chart.js';
import { Bar, getElementAtEvent } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
)

export function getMonth(month) {
  let label = "";

  switch (month) {
    case 0:
      label = "Enero"
      break;

    case 1:
      label = "Enero"
      break;

    case 2:
      label = "Febrero"
      break;

    case 3:
      label = "Marzo"
      break;

    case 4:
      label = "Abril"
      break;

    case 5:
      label = "Mayo"
      break;

    case 6:
      label = "Junio"
      break;

    case 7:
      label = "Julio"
      break;

    case 8:
      label = "Agosto"
      break;

    case 9:
      label = "Septiembre"
      break;

    case 10:
      label = "Octubre"
      break;

    case 11:
      label = "Noviembre"
      break;

    case 12:
      label = "Diciembre"
      break;
  }

  return label;
}

const BarChart = ({ group }) => {

  const date = new Date();
  const month = date.getMonth() + 1;

  let title = "";
  let labels = [];

  switch (month) {
    case 1:
      labels = ['Enero'];
      break;

    case 2:
      labels = ['Enero', 'Febrero'];
      break;

    case 3:
      labels = ['Enero', 'Febrero', 'Marzo'];
      break;

    case 4:
      labels = ['Enero', 'Febrero', 'Marzo', 'Abril'];
      break;

    case 5:
      labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo'];
      break;

    case 6:
      labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio'];
      break;

    case 7:
      labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio'];
      break;

    case 8:
      labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto'];
      break;

    case 9:
      labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre'];
      break;

    case 10:
      labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre'];
      break;

    case 11:
      labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre'];
      break;

    case 12:
      labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      break;
  }

  switch (group) {
    case 'honda_tijuana':
      title = 'Honda - Tijuana';
      break;

    case 'honda_mexicali':
      title = 'Honda - Mexicali';
      break;

    case 'honda_ensenada':
      title = 'Honda - Ensenada';
      break;

    case 'kia_tijuana':
      title = 'Kia - Tijuana';
      break;

    case 'kia_mexicali':
      title = 'Kia - Mexicali';
      break;

    case 'kia_ensenada':
      title = 'Kia - Ensenada';
      break;
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: title
      }
    }
  }

  const data = {
    labels,
    datasets: [
      {
        id: '1',
        label: "Ventas de " + getMonth(month) + " " + date.getFullYear(),
        data: labels.map(() => Math.random() * 100),
        backgroundColor: 'rgba(255, 99, 132, 0.5)'
      },
      {
        id: '2',
        label: "Plan de ventas " + getMonth(month) + " " + date.getFullYear(),
        data: labels.map(() => Math.random() * 100),
        backgroundColor: 'rgba(53, 162, 135, 0.5)'
      },
      {
        id: '3',
        label: "Ventas de " + getMonth(month - 1) + " " + date.getFullYear(),
        data: labels.map(() => Math.random() * 100),
        backgroundColor: 'rgba(53, 162, 135, 0.5)'
      },
    ]
  }

  const chartRef = useRef();
  const navigate = useHistory();

  const printEementAtEvent = (element: InteractionItem[]) => {

    if (!element.length) return;

    const { datasetIndex, index } = element[0];

    let value = "";
    let path = {};

    switch (data.labels[index]) {
      case 'Enero':
        if (group == "honda_tijuana") {
          value = "enero_ht";
        } else if (group == "honda_mexicali") {
          value = "enero_hm";
        } else if (group == "honda_ensenada") {
          value = "enero_he";
        } else if (group == "kia_tijuana") {
          value = "enero_kt";
        } else if (group == "kia_mexicali") {
          value = "enero_km";
        } else if (group == "kia_ensenada") {
          value = "enero_ke";
        }
        break;

      case 'Febrero':
        if (group == "honda_tijuana") {
          value = "febrero_ht";
        } else if (group == "honda_mexicali") {
          value = "febrero_hm";
        } else if (group == "honda_ensenada") {
          value = "febrero_he";
        } else if (group == "kia_tijuana") {
          value = "febrero_kt";
        } else if (group == "kia_mexicali") {
          value = "febrero_km";
        } else if (group == "kia_ensenada") {
          value = "febrero_ke";
        }
        break;

      case 'Marzo':
        if (group == "honda_tijuana") {
          value = "marzo_ht";
        } else if (group == "honda_mexicali") {
          value = "marzo_hm";
        } else if (group == "honda_ensenada") {
          value = "marzo_he";
        } else if (group == "kia_tijuana") {
          value = "marzo_kt";
        } else if (group == "kia_mexicali") {
          value = "marzo_km";
        } else if (group == "kia_ensenada") {
          value = "marzo_ke";
        }
        break;

      case 'Abril':
        if (group == "honda_tijuana") {
          value = "abril_ht";
        } else if (group == "honda_mexicali") {
          value = "abril_hm";
        } else if (group == "honda_ensenada") {
          value = "abril_he";
        } else if (group == "kia_tijuana") {
          value = "abril_kt";
        } else if (group == "kia_mexicali") {
          value = "abril_km";
        } else if (group == "kia_ensenada") {
          value = "abril_ke";
        }
        break;

      case 'Mayo':
        if (group == "honda_tijuana") {
          value = "mayo_ht";
        } else if (group == "honda_mexicali") {
          value = "mayo_hm";
        } else if (group == "honda_ensenada") {
          value = "mayo_he";
        } else if (group == "kia_tijuana") {
          value = "mayo_kt";
        } else if (group == "kia_mexicali") {
          value = "mayo_km";
        } else if (group == "kia_ensenada") {
          value = "mayo_ke";
        }
        break;

      case 'Junio':
        if (group == "honda_tijuana") {
          value = "junio_ht";
        } else if (group == "honda_mexicali") {
          value = "junio_hm";
        } else if (group == "honda_ensenada") {
          value = "junio_he";
        } else if (group == "kia_tijuana") {
          value = "junio_kt";
        } else if (group == "kia_mexicali") {
          value = "junio_km";
        } else if (group == "kia_ensenada") {
          value = "junio_ke";
        }
        break;

      case 'Julio':
        if (group == "honda_tijuana") {
          value = "julio_ht";
        } else if (group == "honda_mexicali") {
          value = "julio_hm";
        } else if (group == "honda_ensenada") {
          value = "julio_he";
        } else if (group == "kia_tijuana") {
          value = "julio_kt";
        } else if (group == "kia_mexicali") {
          value = "julio_km";
        } else if (group == "kia_ensenada") {
          value = "julio_ke";
        }
        break;

      case 'Agosto':
        if (group == "honda_tijuana") {
          value = "agosto_ht";
        } else if (group == "honda_mexicali") {
          value = "agosto_hm";
        } else if (group == "honda_ensenada") {
          value = "agosto_he";
        } else if (group == "kia_tijuana") {
          value = "agosto_kt";
        } else if (group == "kia_mexicali") {
          value = "agosto_km";
        } else if (group == "kia_ensenada") {
          value = "agosto_ke";
        }
        break;

      case 'Septiembre':
        if (group == "honda_tijuana") {
          value = "septiembre_ht";
        } else if (group == "honda_mexicali") {
          value = "septiembre_hm";
        } else if (group == "honda_ensenada") {
          value = "septiembre_he";
        } else if (group == "kia_tijuana") {
          value = "septiembre_kt";
        } else if (group == "kia_mexicali") {
          value = "septiembre_km";
        } else if (group == "kia_ensenada") {
          value = "septiembre_ke";
        }
        break;

      case 'Octubre':
        if (group == "honda_tijuana") {
          value = "octubre_ht";
        } else if (group == "honda_mexicali") {
          value = "octubre_hm";
        } else if (group == "honda_ensenada") {
          value = "octubre_he";
        } else if (group == "kia_tijuana") {
          value = "octubre_kt";
        } else if (group == "kia_mexicali") {
          value = "octubre_km";
        } else if (group == "kia_ensenada") {
          value = "octubre_ke";
        }
        break;

      case 'Noviembre':
        if (group == "honda_tijuana") {
          value = "noviembre_ht";
        } else if (group == "honda_mexicali") {
          value = "noviembre_hm";
        } else if (group == "honda_ensenada") {
          value = "noviembre_he";
        } else if (group == "kia_tijuana") {
          value = "noviembre_kt";
        } else if (group == "kia_mexicali") {
          value = "noviembre_km";
        } else if (group == "kia_ensenada") {
          value = "noviembre_ke";
        }
        break;

      case 'Diciembre':
        if (group == "honda_tijuana") {
          value = "diciembre_ht";
        } else if (group == "honda_mexicali") {
          value = "diciembre_hm";
        } else if (group == "honda_ensenada") {
          value = "diciembre_he";
        } else if (group == "kia_tijuana") {
          value = "diciembre_kt";
        } else if (group == "kia_mexicali") {
          value = "diciembre_km";
        } else if (group == "kia_ensenada") {
          value = "diciembre_ke";
        }
        break;
    }

    path = { pathname: '/test_chart/DayStatistics', params: value }
    navigate.push(path);
  }

  const onClick = (event: MouseEvent<HTMLCanvasElement>) => {
    const { current: chart } = chartRef;

    if (!chart) return;

    printEementAtEvent(getElementAtEvent(chart, event));
  }

  return (
    <Bar
      style={{ height: '50vh' }}
      options={options}
      data={data}
      ref={chartRef}
      onClick={onClick}
    />
  )
}

export default BarChart;